export const spartansResearch = [
    { name: "Sentinel", wood: 1210, clay: 700, iron: 480, crop: 610, all: 3000 },
    { name: "Shieldsman", wood: 970, clay: 480, iron: 2160, crop: 430, all: 4040 },
    { name: "Twinsteel Therion", wood: 880, clay: 900, iron: 3400, crop: 550, all: 5730 },
    { name: "Elpida Rider", wood: 3430, clay: 1880, iron: 2840, crop: 820, all: 8970 },
    { name: "Corinthian Crusher", wood: 4060, clay: 2080, iron: 8160, crop: 1150, all: 15450 },
    { name: "Ram", wood: 3250, clay: 1140, iron: 6520, crop: 940, all: 11850 },
    { name: "Ballista", wood: 3400, clay: 5060, iron: 6800, crop: 970, all: 16230 },
    { name: "Ephor", wood: 17225, clay: 15532, iron: 29392, crop: 8521, all: 70670 }
]